import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TextField,
  Button,
  Box,
  Chip
} from '@mui/material'

const AiTemplateArrayInput = ({
  label,
  placeholder,
  items,
  onAdd,
  onRemove,
  required = false
}) => {
  const { t } = useTranslation()
  const [newValue, setNewValue] = useState('')

  const handleAdd = () => {
    if (newValue.trim()) {
      onAdd(newValue.trim())
      setNewValue('')
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    }
  }

  const handleChipClick = (index, currentValue) => {
    setNewValue(currentValue)
    onRemove(index)
  }

  return (
    <Box>
      <TextField
        fullWidth
        size="small"
        label={required ? `${label} *` : label}
        placeholder={placeholder}
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
        onKeyDown={handleKeyPress}
        InputProps={{
          endAdornment: (
            <Button
              onClick={handleAdd}
              disabled={!newValue.trim()}
              size="small"
            >
              {t('mailTemplate.wizard.ai.add')}
            </Button>
          )
        }}
        sx={{
          mb: 1,
          '& .MuiInputBase-root': {
            height: 40
          }
        }}
      />
      <Box display="flex" flexWrap="wrap" gap={0.5}>
        {items.map((item, index) => {
          const itemValue = item.value || String(item)

          return (
            <Chip
              key={item.id || `${index}-${itemValue}`}
              label={itemValue}
              onClick={() => handleChipClick(index, itemValue)}
              onDelete={() => onRemove(index)}
              size="small"
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default AiTemplateArrayInput
